import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Header from './Header';
import { DropzoneArea } from 'material-ui-dropzone';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import UploadCompleteModal from './UploadCompleteModal';
import Instructions from './Instructions';
import Progress from './Progress';
import { API } from '../config';
import qs from 'query-string';

// import { crc32 } from 'crc';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(5),
  },
}));

export default function Uploader({ location }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [droppedFiles, setDroppedFiles] = useState([]);
  const [droppedFilesCache, setDroppedFilesCache] = useState([]);
  const [uploadStarted, setUploadStarted] = useState(false);
  let [uploadCount, setUploadCount] = useState(0);
  let [progress, setProgress] = useState(1);
  let [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const photographer_id = getURLParams('photographer_id');
    const submission_id = getURLParams('submission_id');
    const talent_submission_id = getURLParams('talent_submission_id');

    if (!(photographer_id || submission_id || talent_submission_id)) {
      let str = '';

      if (photographer_id == null) {
        const email_address = getURLParams('email_address');
        enqueueSnackbar('Invalid URL, Redirecting ', { variant: 'warning' });

        const reqData = {
          email_address,
        };
        axios
          .post(`${API}/get_hiring_id`, reqData)
          .then((d) => {
            if (d.data.success === true) {
              let url = window.location.href;
              console.log('ID found: ', url);
              const query = qs.parse(location.search, {
                ignoreQueryPrefix: true,
              });
              let account_id = d.data.account.Id;
              query.submission_id = account_id.slice(0, -3);
              console.log(qs.stringify(query));
              window.location = `/uploader?${qs.stringify(query)}`;
            } else {
              console.log('inside else: ', d.data.success);
              str = 'Submission';
            }
          })
          .catch((err) => {
            console.log('[I] upload mark failure. ');
          });
      } else {
        str = 'Photographer';
      }
      if (str.length > 0) {
        enqueueSnackbar('Invalid URL, Please provide valid ' + str + ' ID', { variant: 'error' });
      }
      return false;
    }
  }, []);

  const getURLParams = (param) => {
    let parsedURL = decodeURI(location.search);
    const urlParams = new URLSearchParams(parsedURL);
    const parsedParam = urlParams.get(param);
    return parsedParam;
  };
  // const calculateCRC32 = (files) => {
  //   files.forEach((f, i) => {
  //     let reader = new FileReader();
  //     reader.onload = () => {
  //       let dataString = reader.result;
  //       console.log(`CRC:${f.name}: `, crc32(dataString).toString(16));
  //     };
  //     reader.readAsArrayBuffer(f);
  //   });
  // };

  const handleFileUpload = (files) => {
    console.log('[I] Total files droppedd: ', files.length);
    setDroppedFiles(files);

    // calculateCRC32(files);
  };

  const handleClose = (e) => {
    console.log('[I] Complete popup closed. Reset things...');
    //@todo: reset things here in case user uploads things again.
    setModalOpen(false);

    setUploadStarted(false);
    setUploadCount(0);
    setProgress(1);
    setDroppedFiles([]);
    window.location.reload();
  };

  function markUploadStart() {
    console.log('[*] markUploadStart');
    if (getURLParams('talent_submission_id')) {
      let id = getURLParams('talent_submission_id');
      let type = 'tsubmissions';

      const reqData = {
        id,
        type,
        file_name_list: droppedFiles.map((df) => df.name),
      };

      console.log('[I] reqData: ', reqData);

      axios
        .post(`${API}/upload/start`, reqData)
        .then((d) => {
          console.log('[I] upload start marked', d);
        })
        .catch((err) => {
          console.log('[I] upload start mark failure. ');
        });
    } else {
      console.log('upload start only for tsubmissions');
    }
  }

  function markUploadComplete() {
    console.log('[*] markUploadComplete');
    let id, type;
    if (getURLParams('submission_id')) {
      id = getURLParams('submission_id');
      type = 'talents';
    } else if (getURLParams('photographer_id')) {
      id = getURLParams('photographer_id');
      type = 'photogs';
    } else if (getURLParams('talent_submission_id')) {
      id = getURLParams('talent_submission_id');
      type = 'tsubmissions';
    }

    const reqData = {
      id,
      type,
      file_name_list: droppedFiles.map((df) => df.name),
    };
    console.log('[I] reqData: ', reqData);

    axios
      .post(`${API}/upload/complete`, reqData)
      .then((d) => {
        console.log('[I] upload mark done', d);
      })
      .catch((err) => {
        console.log('[I] upload mark failure. ');
      });
  }

  const handleStartUpload = (e) => {
    e.preventDefault();
    console.log('[I] File upload to server started', droppedFiles.length);

    const photographer_id = getURLParams('photographer_id');
    const submission_id = getURLParams('submission_id');
    const talent_submission_id = getURLParams('talent_submission_id');

    if (!(photographer_id || submission_id || talent_submission_id)) {
      enqueueSnackbar('Invalid URL', { variant: 'error' });
      return false;
    }

    if (droppedFiles.length < 1) {
      enqueueSnackbar('No files selected.', { variant: 'error' });
      return false;
    }

    markUploadStart();
    setUploadStarted(true);

    droppedFiles.forEach((file, index) => {
      console.log('[I] Getting signed url for', index);
      axios
        .post(`${API}/getSignedUrl`, {
          photographer_id,
          submission_id,
          talent_submission_id,
          // first_name: getURLParams('first_name'),
          // last_name: getURLParams('last_name'),
          application_date: getURLParams('application_date'),
          Email: getURLParams('email_address'),
          Filename: file.name,
          ContentType: file.type,
          Action: 'WRITE',
        })
        .then((signedData) => {
          console.log(`Signed URL ${index}:, ${signedData.data.data}`);
          const signedUrl = signedData.data.data;
          axios
            .put(`${signedUrl}`, file, {
              headers: {
                'Content-Type': file.type,
              },
            })
            .then((putResponse) => {
              console.log(`[I] File: uploaded: ${index}:${file.name}`, putResponse);
              setUploadCount(++uploadCount);
              setProgress(Math.ceil((uploadCount * 100) / droppedFiles.length));

              if (uploadCount >= droppedFiles.length) {
                markUploadComplete();
                // setModalOpen(true);
                setTimeout(setModalOpen, 1000, true);
                enqueueSnackbar('File upload completed.', { variant: 'success' });
              }
            })
            .catch((s3PutErr) => {
              console.log('[E] Error uploading to s3', s3PutErr);
              enqueueSnackbar('File upload error.', { variant: 'error' });
            });
        })
        .catch((signingErr) => {
          console.log('[E] Error getting signed url', signingErr);
          enqueueSnackbar('File upload sign error.', { variant: 'error' });
        });
    });
  };

  // function isImageNameRepeated() {
  //   let temp_filenames = droppedFiles.map((df) => df.name);
  //   for (let i = 0; i < temp_filenames.length; i++) {
  //     for (let j = 0; j < temp_filenames.length; j++) {
  //       if (temp_filenames[i] === temp_filenames[j] && i !== j) {
  //         console.log(`${temp_filenames[i]} is duplicate.`);
  //         return temp_filenames[i];
  //       }
  //     }
  //   }
  //   return false;
  // }

  // const checkDuplication = () => {
  //   let repeatedImageName = isImageNameRepeated();
  //   let repeatFileIndex = -1;
  //   if (repeatedImageName) {
  //     repeatFileIndex = droppedFiles.findIndex((df) => df.name === repeatedImageName);
  //   }

  //   if (repeatFileIndex > -1) {
  //     console.log('Repeat Index: ' + repeatFileIndex);
  //     //remove that element from array and get new array.
  //     let UpdatedDroppedFiles = [...droppedFiles.slice(0, repeatFileIndex), ...droppedFiles.slice(repeatFileIndex + 1)];
  //     console.log('updated drop files: ', UpdatedDroppedFiles);
  //     setDroppedFiles(UpdatedDroppedFiles);
  //   }
  // };

  // useEffect(checkDuplication, [droppedFiles]);

  return (
    <div>
      <Header />
      <Instructions />
      {uploadStarted ? <Progress progress={progress} /> : ''}

      <Paper className={classes.root}>
        <Button
          onClick={handleStartUpload}
          disabled={droppedFiles.length ? false : true}
          variant="contained"
          color="secondary"
          style={{ float: 'right' }}
        >
          Start Upload
        </Button>
        <div>Total Files: {droppedFiles.length}</div>

        <DropzoneArea
            maxFileSize={50000000}
            filesLimit={500}
            dropzoneProps={{ maxFiles: 500 }}
            multiple
            acceptedFiles={['image/jpeg', 'image/jpg']}
            onChange={handleFileUpload}
            style={{ height: 200, padding: '20px' }}
            previewGridProps={{
              item: { lg: '3' },
            }}
        />
      </Paper>
      <UploadCompleteModal handleClose={handleClose} imageCount={uploadCount} open={modalOpen} />
    </div>
  );
}
